import React, { Fragment, useState, useEffect } from "react";
import { Input } from '../core/Forms';
import PhoneNumber from './PhoneNumber';
import { useApi } from '../../services/api';


function SelectRecoveryMethod({ recoveryIntent, getRecoveryIntent }){

	const [ selectRecoveryMethod, setSelectRecoveryMethod ] = useState();

	useEffect( () => {
		if(recoveryIntent.isError){
		}else if(recoveryIntent.isLoading){
		}else if(recoveryIntent.data.recovery_intent.select_recovery_method){
			const selectRecoveryMethod = recoveryIntent.data.recovery_intent.select_recovery_method;
			
			setSelectRecoveryMethod(selectRecoveryMethod);
		}
	}, [recoveryIntent]);

	function sendPhoneSMS(){
		const recovery_intent = { 
			select_recovery_method: { 
				hidden_phone_number: { send_otp: true } } };

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent }
		});
	}

	function submitCode(confirmation_code){
		const recovery_intent = { 
			select_recovery_method: { 
				hidden_phone_number: { confirmation_code } } };

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent }
		});
	}


	function submitEmail(event){
		event.preventDefault();

		const select_recovery_method = { send_instructions: true };

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { select_recovery_method } }
		});

		return false;
	}

	let phoneNumber;
	if(selectRecoveryMethod && selectRecoveryMethod.hidden_phone_number){
		phoneNumber = selectRecoveryMethod.hidden_phone_number; }

	return (<Fragment>
		<h2>Recupera tu acceso a Saeko</h2>
		<p className="text-muted mb-3">Elige una opción:</p>
		<p className="text-muted mb-5">Si no reconoces o no tienes acceso al correo electrónico acude a tu Institución para actualizar tus datos personales y recuperar tu acceso a Saeko.</p>

		{phoneNumber && <PhoneNumber
			submitPhone={sendPhoneSMS}
			submitCode={submitCode}
			phoneNumber={phoneNumber}
			isLoading={recoveryIntent.isLoading}
			canEdit={false}
			onTimePasswordMode={true} />}

		<hr className="mt-1 mb-3" />
		
		<form onSubmit={submitEmail}>
			<div className="form-row">
				<Input name="email" label="Correo Electrónico" className="form-group col-8"
					initialValueObject={selectRecoveryMethod} initialValueKey="hidden_email"
					description="Aquí recibirás un enlace para poder recuperar tu cuenta"
					disabled={true} />

				<div className="form-group col-4">
					<button type="submit" className="btn btn-primary w-100 mt-4" disabled={recoveryIntent.isLoading}>
						{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
						Enviar
					</button>
				</div>
			</div>
		</form>
	</Fragment>);
}

export default SelectRecoveryMethod;
